import { render, staticRenderFns } from "./suoritteet.vue?vue&type=template&id=329a26b0&scoped=true&"
import script from "./suoritteet.vue?vue&type=script&lang=ts&"
export * from "./suoritteet.vue?vue&type=script&lang=ts&"
import style0 from "./suoritteet.vue?vue&type=style&index=0&id=329a26b0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "329a26b0",
  null
  
)

export default component.exports